import i18n from 'i18next';
import { initReactI18next } from "react-i18next";
import en from '../../locales/en.json';
import fr from '../../locales/fr.json';
import config from 'root/../config'

i18n
    .use(initReactI18next)
    .init({
        lng: window.localStorage.userLanguage ? window.localStorage.userLanguage : window.userLanguage ? window.userLanguage : config.language.primaryLng ,
        fallbackLng: config.language.fallbackLng,
        debug: false,
        initImmediate: true,
        nsSeparator: false,
        keySeparator: false,
        resources: {
            en: {
                translation: en
            },
            fr: {
                translation: fr
            },
        }
    });
    
export { i18n as i18nInit };